import get from 'lodash/get';
import React from 'react';

import I18n from '../i18n';
import styled from '../styled-components';

type PropType = {
    theme: any;
    locale?: string;
    data: any;
};

const ApiResponseDisplayer = ({ theme, locale = 'en', data }: PropType) => {
    if (!data) return null;
    const errors = I18n.lApi(data);

    return (
        <Wrapper theme={theme}>
            {errors &&
                errors.map((error: any, key: number) => <Message key={`${error}-${key}`}>{error}</Message>)}
        </Wrapper>
    );
};

const Wrapper = styled.div`
  color: ${({ theme }) => get(theme, 'standard.red')};
  font-weight: normal;
  padding: 20px 0 10px 0;
  text-align: center;
  width: 100%;
`;

const Message = styled.p`
  font-weight: normal;
`;

export default ApiResponseDisplayer;
